import * as React from 'react'

const SpecificLogoSvg = ({
  width,
  className,
}: {
  width: number
  className?: string
}) => (
  <svg
    className={className}
    width={width}
    height={width * (428 / 1400)}
    viewBox="0 0 1400 428"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_5782_45027)">
      <path
        d="M14.3664 111.85C14.3664 73.7896 47.7611 38.8309 95.9225 38.8309C144.084 38.8309 173.977 69.1271 189.514 92.8199L156.509 113.011C142.533 92.8199 121.554 77.6717 95.9225 77.6717C70.2911 77.6717 57.0853 94.3707 57.0853 111.85C57.0853 169.331 192.615 151.081 192.615 247.003C192.615 290.116 155.339 323.124 105.627 323.124C47.7612 323.124 18.2481 292.057 0 256.708L33.785 236.507C48.9317 262.921 69.5108 284.283 105.627 284.283C131.258 284.283 149.896 270.685 149.896 247.003C149.896 186.8 14.3664 201.558 14.3664 111.85Z"
        fill="currentColor"
      />
      <path
        d="M270.29 111.08V130.89C290.098 113.801 314.169 104.866 334.368 104.866C382.91 104.866 437.284 143.707 437.284 214.005C437.284 284.303 382.92 323.144 334.368 323.144C314.179 323.144 290.098 314.209 270.29 297.12V394.602H227.571V111.08H270.29ZM334.368 284.303C365.052 284.303 394.955 261.39 394.955 214.005C394.955 169.341 365.442 143.707 334.368 143.707C301.363 143.707 270.29 170.121 270.29 214.005C270.29 257.889 300.973 284.303 334.368 284.303Z"
        fill="currentColor"
      />
      <path
        d="M512.617 233.415C519.61 267.594 545.622 284.293 575.145 284.293C596.114 284.293 615.533 275.748 627.188 258.659L661.753 279.24C641.174 307.976 607.769 323.124 575.155 323.124C522.732 323.124 468.357 283.903 468.357 213.985C468.357 144.067 518.84 104.846 571.273 104.846C623.706 104.846 681.562 147.569 673.798 233.405H512.637L512.617 233.415ZM627.958 198.847C624.857 166.219 601.546 143.697 571.263 143.697C540.98 143.697 516.899 163.508 511.847 198.847H627.958ZM627.178 258.659L661.743 279.24L627.178 258.659Z"
        fill="currentColor"
      />
      <path
        d="M747.961 214.005C747.961 261.39 777.864 284.303 812.43 284.303C833.399 284.303 852.818 275.758 864.473 258.669L899.038 279.25C878.459 307.986 845.054 323.134 812.43 323.134C760.006 323.134 705.632 283.913 705.632 213.995C705.632 144.077 759.996 104.856 812.43 104.856C845.054 104.856 878.449 120.004 899.038 148.74L864.473 169.321C852.818 152.232 833.399 143.687 812.43 143.687C777.484 143.687 747.961 169.321 747.961 213.985V214.005ZM899.028 148.76L864.463 169.341L899.028 148.76ZM864.463 258.669L899.028 279.25L864.463 258.669Z"
        fill="currentColor"
      />
      <path
        d="M1009.32 111.08L954.953 316.92H910.684L965.048 111.08H1009.32Z"
        fill="currentColor"
      />
      <path
        d="M1152.24 0C1180.59 0 1207.38 15.5384 1224.47 38.0605L1189.91 59.0317C1180.97 47.3855 1167.38 38.0605 1151.46 38.0605C1133.2 38.0605 1112.23 50.8773 1104.47 80.7834L1033.02 350.708C1019.42 401.586 980.204 428 941.757 428C913.404 428 886.612 412.462 869.525 389.94L904.09 368.968C913.024 380.625 926.61 389.94 942.537 389.94C960.795 389.94 981.765 377.123 989.528 347.217L1060.98 77.2915C1074.58 26.4142 1113.79 0 1152.24 0Z"
        fill="currentColor"
      />
      <path
        d="M1183.3 111.08L1128.94 316.92H1084.67L1139.03 111.08H1183.3Z"
        fill="currentColor"
      />
      <path
        d="M1248.93 214.005C1248.93 261.39 1278.84 284.303 1313.4 284.303C1334.37 284.303 1353.79 275.758 1365.44 258.669L1400.01 279.25C1379.43 307.986 1346.03 323.134 1313.4 323.134C1260.98 323.134 1206.6 283.913 1206.6 213.995C1206.6 144.077 1260.97 104.856 1313.4 104.856C1346.03 104.856 1379.42 120.004 1400.01 148.74L1365.44 169.321C1353.8 152.232 1334.37 143.687 1313.4 143.687C1278.46 143.687 1248.93 169.321 1248.93 213.985V214.005ZM1400 148.76L1365.43 169.341L1400 148.76ZM1365.43 258.669L1400 279.25L1365.43 258.669Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_5782_45027">
        <rect width="1400" height="428" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default SpecificLogoSvg
